import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { strings } from '../../resources/strings';

export class TicketInfo extends Component {
    render() {
        return (
            <Container fluid className="mb-5 tariff">
                <Row className="mt-5" style={{ backgroundColor: '#e9ecef' }}>
                    <p
                        className="ticket-info-title"
                        dangerouslySetInnerHTML={{ __html: strings.ticketInfoTitle }}
                    />

                    <a
                        href="docs/Tarifas_Cubo.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: '0.8rem' }}
                    >
                        <p dangerouslySetInnerHTML={{ __html: strings.ticketInfoTitleDownload }} />
                    </a>
                </Row>
                <Row style={{ marginTop: "3rem" }}>
                    <Col>
                        <iframe
                            src="docs/Tarifas_Cubo.pdf"
                            title="Tarifário Cubo"
                            style={{
                                width: "100%",
                                height: "80vh",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px"
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }
}
